import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";
import { Bar, Pie } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
);

function FinalResultsCharts({ questions }) {
  const backgroundColors = [
    "#FF6384",
    "#36A2EB",
    "#FFCE56",
    "#4BC0C0",
    "#9966FF",
    "#FF9F40",
    "#C9CBCF",
  ];

  const getVwFontSize = (vwValue) => {
    return Math.max(8, (window.innerWidth * vwValue) / 100);
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[1vw] my-[1vw] px-[1vw]">
      {questions?.map((q, index) => {
        const labels = q.options || [];
        const values = q.results || [];

        const data = {
          labels,
          datasets: [
            {
              label: "Responses",
              data: values,
              backgroundColor: backgroundColors.slice(0, labels.length),
              borderWidth: 2,
              borderColor: "#fff",
              font: {
                size: getVwFontSize(0.4)
              }
            },
          ],
        };

        const options = {
          responsive: true,
          maintainAspectRatio: false,
          animation: false, 
          hover: {
            mode: null 
          },
          plugins: {
            legend: {
              display: false
            },
            tooltip: {
              enabled: false 
            }
          },
        };

        return (
          <div className="p-[1vw] bg-white rounded-[0.5vw] border border-gray-200" key={index}>
            <div
              className="flex flex-col items-center"
            >
              <h3 className="text-[1vw] font-semibold mb-6 text-center text-gray-800">
                {q.question}
              </h3>
            </div>
            <div className="w-full h-auto">
              <div className="w-auto h-auto flex flex-col items-center justify-center">
                <div className="w-full h-[15vw] flex items-center justify-center">
                  <Pie data={data} options={options} />
                </div>
                <div className="mt-[1vw] w-full overflow-auto max-h-[15vw] scrollbar-thin scrollbar-thumb-gray-200">
                  <table className="w-full text-[0.8vw] table-fixed border-collapse">
                    <thead className="sticky top-0 bg-white z-10">
                      <tr>
                        <th className="text-left text-gray-600 pb-2 w-[70%] border-b border-gray-200">Option</th>
                        <th className="text-right text-gray-600 pb-2 w-[12%] border-b border-gray-200">Count</th>
                        <th className="text-right text-gray-600 pb-2 w-[18%] border-b border-gray-200">Percentage</th>
                      </tr>
                    </thead>
                    <tbody>
                      {labels.map((label, i) => {
                        const total = values.reduce((a, b) => a + b, 0);
                        const percentage = total > 0 ? ((values[i] || 0) / total * 100).toFixed(1) : "0.0";
                        const optionColor = backgroundColors[i % backgroundColors.length];
                        const labelText = typeof label === 'object' ? label.choice_text : label;
                        return (
                          <tr key={i} className="hover:bg-gray-50 transition-colors">
                            <td className="text-left text-gray-700 border-b border-gray-200 py-[0.6vw] pr-[0.5vw]">
                              <div className="flex items-start overflow-hidden">
                                <div 
                                  className="w-[0.8vw] h-[0.8vw] rounded-full mr-[0.5vw] mt-[0.3vw] flex-shrink-0" 
                                  style={{ backgroundColor: optionColor }}
                                ></div>
                                <span className="truncate block" title={labelText}>
                                  {labelText}
                                </span>
                              </div>
                            </td>
                            <td className="text-right text-gray-700 border-b border-gray-200 py-[0.6vw] font-medium">{values[i] || 0}</td>
                            <td className="text-right text-gray-700 border-b border-gray-200 py-[0.6vw] font-semibold text-blue-600">{percentage}%</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default FinalResultsCharts;
